var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"timestamp font-text"},[_c('i',{staticClass:"fa-regular fa-calendar"}),_vm._v("\n    "+_vm._s(_vm.$timestamp(_vm.string))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }